import { HighlightOff, Print } from "@mui/icons-material";
import { Box, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Link, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { generateSubSchedule } from "../utils/generateSubSchedule";

export default function SubstitutesAvailableList({ periods, date, availableSubstitutes, coveragePeriods }) {
  const headers = ['Name', '# of Periods', 'Actions']
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box width={'100%'}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index}>
                  {t(header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {availableSubstitutes?.map((item, index) => (
              <TableRow key={`self-eval-${index}`}>
                <TableCell>
                  <Stack>
                    <Typography variant="body2">
                      {item?.substituteName} ({item?.jobTitle})
                    </Typography>
                    <Typography variant="body2" color={'text.secondary'}>
                      {item?.phone}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Link>{item.count} periods</Link>
                </TableCell>
                <TableCell>
                  <IconButton aria-label="print" onClick={() => {
                    const matchingPeriods = coveragePeriods
                      .flatMap(coverage => coverage.periods)
                      .filter(period => period.substituteId === item.substituteId)
                    generateSubSchedule(item, date, periods, matchingPeriods)}}>
                    <Print />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => navigate('/')}>
                    <HighlightOff />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
